import React, { useState } from 'react';
import { Table, Button, Typography, Modal, Tag, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import { compose } from '@reduxjs/toolkit';
import { isNull } from 'lodash';
import { BarChartOutlined, DeleteOutlined } from '@ant-design/icons';
import DialogUnbindPartner from '../Dialogs/DialogsUnbinPartner';

const { Link, Text } = Typography;

const OwnerTable = ({ items, depotCode, refetch }) => {
  const [users, setUsers] = useState(null);
  const [openUnbin, setOpenUnbin] = useState(false);
  const { t } = useTranslation(['admin']);

  const handleOpenDialogUnbindUser = (record) => {
    setUsers(record);
    setOpenUnbin(true);
  };

  const getColumns = () => [
    {
      title: 'Công ty/đối tác',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Tên viết tắt',
      dataIndex: 'short_name',
      key: 'short_name'
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone_number',
      key: 'phone_number'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      key: 'address'
    },
    {
      title: '',
      key: 'unbind',
      render: (text, record) => (
        <Space>
          <Tag color="green">Hoạt động</Tag>
          <a onClick={() => handleOpenDialogUnbindUser(record)}>
            <DeleteOutlined style={{ color: '#52525B' }} />
          </a>
        </Space>
      )
    }
  ];

  return (
    <>
      <DialogUnbindPartner
        depotCode={depotCode}
        users={users}
        openUnbin={openUnbin}
        setOpenUnbin={setOpenUnbin}
        refetch={refetch}
      />
      <div style={{ width: '100%', overflow: 'auto', marginTop: '10px' }}>
        <Table
          style={{ marginTop: '10px' }}
          columns={getColumns()}
          dataSource={items || []}
          rowKey="userId"
          pagination={false}
        />
      </div>
    </>
  );
};

export default compose(withPaginate)(OwnerTable);
